import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useAppSelector } from '@/redux/store';

import { ModalContext } from '../Modals/Modal/config';
import { StringSmall, StringXSmall } from '../Typography/Typography';
import { Button } from '../ui/Button/Button';
import { CurrencyImage } from '../ui/CurrencyImage/CurrencyImage';
import { Plus } from '../ui/Plus/Plus';

import css from './styles.module.scss';

interface CoinBalanceTopUpProps {
  className?: string;
  contenctClassName?: string;
  compare?: number;
  iconSize?: string;
}

const CoinBalanceTopUp: FC<CoinBalanceTopUpProps> = ({
  compare,
  className,
  contenctClassName,
  iconSize,
}) => {
  const { isOpen, openModal, secondModal } = useContext(ModalContext);
  const { t } = useTranslation();
  const coinBalance = useAppSelector((state) => state.user.user?.balance.tgem);

  const onClick = (): void => {
    if (isOpen) {
      secondModal.openModal({
        renderKind: 'coinDeposit',
        props: { source: 'coin_balance_topup' },
      });
    } else {
      openModal({
        renderKind: 'coinDeposit',
        props: { source: 'coin_balance_topup' },
      });
    }
  };

  return (
    <div className={cn(css.wrapper, !compare && 'pr-4', className)}>
      <CurrencyImage size={iconSize || '1.5rem'} kind="tgem" />
      <div
        className={cn(
          'flex flex-col items-center gap-[2px]',
          contenctClassName,
        )}
      >
        <StringXSmall weight="regular" className="!text-white/40">
          {t('Balance')}
        </StringXSmall>
        <StringSmall weight="bold" className="!text-white">
          {coinBalance || 0}
        </StringSmall>
      </div>
      {compare && (
        <Button className="!w-auto" onClick={onClick}>
          <Plus
            className="!w-7 !h-7"
            variant={
              compare > (coinBalance || 0) ? 'green-header' : 'grey-header'
            }
          />
        </Button>
      )}
    </div>
  );
};

export { CoinBalanceTopUp };
